import request from './request'

export function listNumberRule(data) {
  return request.post('/mes/number-rules/list', data)
}
export function getNumberRule(id) {
  return request.get('/mes/number-rules/' + id)
}
export function saveNumberRule(data) {
  return request.post('/mes/number-rules', data)
}
export function updateNumberRule(data) {
  return request.post('/mes/number-rules/update', data)
}
export function deleteNumberRule(ids) {
  return request.post('/mes/number-rules/delete', ids)
}
export function previewNumberRule(ruleCode) {
  return request.get('/mes/number-rules/preview/' + encodeURIComponent(ruleCode))
}
export function nextNumberRule(ruleCode) {
  return request.post('/mes/number-rules/next/' + encodeURIComponent(ruleCode))
}
